var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.2292C13.2782 11.2292 15.125 9.38242 15.125 7.10425C15.125 4.82607 13.2782 2.97925 11 2.97925C8.72183 2.97925 6.875 4.82607 6.875 7.10425C6.875 9.38242 8.72183 11.2292 11 11.2292Z",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.001 11.2292C7.53651 11.2292 5.3814 13.2195 4.5357 15.854C4.07148 17.3001 5.35725 18.5626 6.87604 18.5626H9.39702",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5086 14.9417C17.9642 14.9417 18.3336 14.5724 18.3336 14.1167C18.3336 13.6611 17.9642 13.2917 17.5086 13.2917C17.053 13.2917 16.6836 13.6611 16.6836 14.1167C16.6836 14.5724 17.053 14.9417 17.5086 14.9417Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2781 11.5032C18.8476 11.5032 20.1204 12.776 20.1204 14.3454C20.1202 15.9146 18.8475 17.1867 17.2781 17.1867C16.9741 17.1867 16.6818 17.1373 16.4071 17.0488L14.4368 19.02H12.6035V17.1867L14.5738 15.2155C14.4856 14.9412 14.4368 14.649 14.4368 14.3454C14.4368 12.7761 15.7089 11.5034 17.2781 11.5032Z",
    stroke: "#171717",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserKey);
export default __webpack_public_path__ + "static/media/icon_user_key.89eb7752e4ae49c0adedf3c7421ea141.svg";
export { ForwardRef as ReactComponent };